import axios from "axios";

axios.defaults.withCredentials = true;

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const api = {
  // auth
  me: () => axios.get(`${API}/auth/me`).then((r) => r.data),
  login: (email, password) => axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data),
  register: (email, password, name) =>
    axios.post(`${API}/auth/register`, { email, password, name }).then((r) => r.data),
  logout: () => axios.post(`${API}/auth/logout`).then((r) => r.data),
  forgotPassword: (email) =>
    axios.post(`${API}/auth/forgot-password`, { email }).then((r) => r.data),
  resetPassword: (token, password) =>
    axios.post(`${API}/auth/reset-password`, { token, password }).then((r) => r.data),

  // documents
  listDocuments: () => axios.get(`${API}/documents`).then((r) => r.data),
  uploadDocument: (file, onProgress) => {
    const form = new FormData();
    form.append("file", file);
    return axios
      .post(`${API}/documents/upload`, form, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (e) => {
          if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
        },
      })
      .then((r) => r.data);
  },
  getPassages: (id) => axios.get(`${API}/documents/${id}/passages`).then((r) => r.data),
  deleteDocument: (id) => axios.delete(`${API}/documents/${id}`).then((r) => r.data),
  clearDocuments: () => axios.delete(`${API}/documents`).then((r) => r.data),

  // chat
  sendChat: (message) => axios.post(`${API}/chat`, { message }).then((r) => r.data),
  getHistory: () => axios.get(`${API}/chat/history`).then((r) => r.data),
  clearHistory: () => axios.delete(`${API}/chat/history`).then((r) => r.data),

  // embed widget
  getWidgetKey: () => axios.get(`${API}/widget-key`).then((r) => r.data),
  getWidgetStatus: () => axios.get(`${API}/widget/status`).then((r) => r.data),
  regenerateWidgetKey: () => axios.post(`${API}/widget-key/regenerate`).then((r) => r.data),

  // billing
  getBilling: () => axios.get(`${API}/billing/status`).then((r) => r.data),
  createCheckout: (origin, lookupKey = "pro_monthly") =>
    axios.post(`${API}/payments/checkout`, { lookup_key: lookupKey, origin_url: origin }).then((r) => r.data),
  paymentStatus: (sessionId) => axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data),
  billingPortal: (returnUrl) =>
    axios.post(`${API}/payments/portal`, { return_url: returnUrl }).then((r) => r.data),
};
